import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

type Props = {
  message: string;
  filterApplied?: boolean;
  onClearFilter?: () => void;
};

export const EmptyListComponent = ({ message, filterApplied, onClearFilter }: Props) => {
  return (
    <Card className="text-center p-4 bg-light border-0 shadow-sm rounded">
      <Card.Body>
        <FontAwesomeIcon icon={faInbox} className="text-secondary mb-3" size="3x" />
        <Card.Title className="text-dark">{message}</Card.Title>
        {filterApplied && onClearFilter && (
          <button 
            onClick={onClearFilter}
            className="btn btn-outline-primary btn-sm mt-2"
          >
            Clear Filters
          </button>
        )}
      </Card.Body>
    </Card>
  );
}; 